export const Wordmark = ({ size = "md", inverted = false, tagline = true }) => {
  const big = size === "lg";
  return (
    <div className="flex flex-col leading-none" data-testid="sist-wordmark">
      <span className={`font-brand font-extrabold tracking-tight ${big ? "text-5xl" : "text-2xl"} ${inverted ? "text-white" : "text-[#0B3D91] dark:text-white"}`}>
        SIST<span className="text-[#E11D2E]">.</span>
      </span>
      {tagline && (
        <span className={`font-brand font-medium mt-1 ${big ? "text-sm" : "text-[10px]"} ${inverted ? "text-white/75" : "text-muted-foreground"}`}>
          Sistem Informasi Sekolah Terpadu
        </span>
      )}
    </div>
  );
};
